import React, { useEffect, useRef, useState } from "react";
import Header from "../../../components/global/Header";
import LeftNavbar from "../../../components/global/LeftNavbar";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { confirmAlert } from "react-confirm-alert";
import DataTable from "react-data-table-component";
import $, { event } from "jquery";
import Constants from "../../../Constants";
import { Link } from "react-router-dom";
import { Breadcrumb } from "../../../components/dashboard/Breadcrumb";
import {
  getAxiosResponse,
  deleteAxiosResponse,
  putAxiosResponse,
  postAxiosResponse,
} from "../../../services/authApiRoutes/APImethods";
import APIUrls from "../../../services/APIUrls";
import { handleError } from "../../../services/authApiRoutes/APImethods";
import { BackArrowIcon, DeleteIconBold, EditPenIconReviewWorkflow } from "../../../AppIcons";
import { openNewTab } from "../../../services/Util";
export default function SystemSettingCompanyDepartment() {
  const scrollRef = useRef(null);
  const backRef = useRef();
  const { t } = useTranslation();
  const [pending, setPending] = useState(true);
  const translate = t;
  const navigate = useNavigate();
  const [error,setError] = useState('')
  const [activeUserGroup, setActiveUserGroup] = useState([]);
  const [unAssignedGroup, setUnAssignedGroup] = useState([]);
  const [conDepartment, setConDepartment] = useState(false);
  const [departmentToRename, setDepartmentToRename] = useState({});
  const [departmentName, setDepartmentName] = useState("");

  const columns = [
    {
      id: "userGroup.id",
      name: "Name",
      selector: (row) => row.name,
      sortable: true,
      cell: (row) => row.name,
    },
    {
      id: "userGroup.totalUsers",
      name: "Users",
      selector: (row) => row.totalUsers,
      sortable: true,
      cell: (row) => row.totalUsers,
    },
    {
      id: "userGroup.totalProjects",
      name: "Projects",
      selector: (row) => row.totalProjects,
      sortable: true,
      cell: (row) => row.totalProjects,
    },
    {
      name: "Action",
      center: true,
      selector: (row) => row.bidType,
      cell: (row) => (
        <>
          <button className={!row.deleteable ? "mr-15 inline-flex" : "mr-15 inline-flex"} disabled={!row.deleteable} aria-label="delete"
            onClick={row.deleteable ? () => confirmDelete(row) : null} >
            {DeleteIconBold}
          </button>
          <button className="inline-flex" aria-label="rename" onClick={() => showRenameModal(row)} >
            {EditPenIconReviewWorkflow}
          </button>
        </>
      )
    }
  ];

  const unAssignedColumns = [
    {
      id: "userId",
      name: "Users",
      selector: (row) => row.firstName,
      sortable: true,
      cell: (row) => <Link to={`/settings/my-account-profile/${row.userId}`}>{row.firstName+" "+row.lastName}</Link>
    },
    {
      id: "totalProjects",
      name: "Projects",
      selector: (row) => row.unassignedProjectCount,
      sortable: true,
      cell: (row) => row.unassignedProjectCount,
    }
  ];
  const noDataFoundComponent = () => {
    return (
      <div className="no-data-display align-center">
        <i className="nodata-icon"></i>
        <p>{Constants.NO_DATA_FOUND}</p>
      </div>
    );
  };
  const showAddModal = () => {
    setConDepartment(true);
    document.body.classList.add("modal-open");
    setTimeout(() => {
      $(".first-focus").trigger("focus");
      $("#addDepartmentInput").on("keydown", function (e) {
        if (e.key === Constants.TAB) {
         if (e.shiftKey === true) {
            e.preventDefault();
            $("#addDepartment").trigger("focus");
          }
        }
      });
      $(".inner-lightbox-panel").on("keydown", function (e) {
        if (e.key === Constants.ESCAPE) {
          hideAddModal();
          $('.focusAdd').trigger('focus');
          $('.heading-with-rightbtn .blue-btn').removeClass('focusAdd');
        }
      });
    }, 500);
  };
  const handleKeyAddflow = (event) => {
    if (event.key === Constants.TAB) {
      if (event.shiftKey === false) {
        event.preventDefault();
        $("#addDepartmentInput").trigger("focus");
      }
    }
  };
  const hideAddModal = () => {
    setDepartmentName("");
    document.body.classList.remove("modal-open");
  };
  const createDepartment = () => {
    if(departmentName === ""){
      setError('Add Department Name');
      setTimeout(() => {
        $("#addDepartmentInput").trigger("focus");
     }, 100);
    }
  else{
    var filterName = activeUserGroup.filter((group)=> group.name.toLowerCase() === departmentName.toLowerCase()
    )
    if(filterName.length === 0){
      hideAddModal();
      var payload = { id: null, name: departmentName };
    postAxiosResponse(APIUrls.UPDATE_DEPARTMENT(null), payload)
      .then((res) => {
        getDate();
      })
      .catch((err) => {
        handleError(err);
      });
    }else{
    setError('Department exists already')
    }
    $(".heading-with-rightbtn .blue-btn").trigger("focus");
  }
    
  };
  const renameDepartment = () => {
    var departName =
      departmentName !== "" ? departmentName : departmentToRename.name;
    var payload = { id: departmentToRename.id, name: departName };
    hideRenameModal();
    putAxiosResponse(APIUrls.UPDATE_DEPARTMENT(departmentToRename.id), payload)
      .then((res) => {
        getDate();
      })
      .catch((err) => {
        handleError(err);
      });
  };
  
  const confirmDelete = (row) => {
    
    setTimeout(() => {
      $("#deleteNo").trigger("focus");
      $("#react-confirm-alert").attr( { role:"dialog", 'aria-modal':"true", 'aria-label':"confirm delete" } ); 
    }, 500);
    confirmAlert({
      title: "Confirm Delete",
      message: <p>{`Delete ${row.name} Department.`}</p>,
      buttons: [
        {
          label: "Yes",
          id: "deleteYes",
          onClick: () =>
            deleteAxiosResponse(APIUrls.UPDATE_DEPARTMENT(row.id))
              .then((res) => {
                getDate();
              })
              .catch((err) => {
                handleError(err);
              }),
              onKeyDown: (e) => {
                if (e.key === "Tab") {
                  if (e.shiftKey === true) {
                    e.preventDefault();
                    $("#deleteNo").trigger("focus");
                  }
                }
              },
        },
        {
          label: "No",
          id: "deleteNo",
          onClick: () => {
            $('.focusAdd').trigger('focus');
            $('.inline-flex').removeClass('focusAdd');
          },
          onKeyDown: (e) => {
            if (e.key === "Tab") {
              if (e.shiftKey === false) {
                e.preventDefault();
                $("#deleteYes").trigger("focus");
              }
            }
            if (e.key === Constants.ESCAPE) {
               $('.focusAdd').trigger('focus');
               $('.inline-flex').removeClass('focusAdd');
             }
          },
        },
      ],
      closeOnEscape: true,
      closeOnClickOutside: true,
      overlayClassName: "delete_overlay",
      
    });
  };
  const showRenameModal = (row) => {
    setDepartmentToRename(row);
    setConDepartment(false);
    document.body.classList.add("modal-open");
    setTimeout(() => {
      $(".first-focus").trigger("focus");
      $("#renameInput").on("keydown", function (e) {
        if (e.key === Constants.TAB) {
         if (e.shiftKey === true) {
            e.preventDefault();
            $("#SaveId").trigger("focus");
          }
        }
      });
      $(".inner-lightbox-panel").on("keydown", function (e) {
        if (e.key === Constants.ESCAPE) {
          hideRenameModal();
          $('.focusAdd').trigger('focus');
          $('.inline-flex').removeClass('focusAdd');
        }
      });
    }, 500);
  };
  const handleKeyEditflow = (event) => {
    if (event.key === Constants.TAB) {
      if (event.shiftKey === false) {
        event.preventDefault();
        $("#renameInput").trigger("focus");
      }
    }
  };
  const hideRenameModal = () => {
    var newstate = departmentToRename;
    newstate = {};
    setDepartmentName("");
    setDepartmentToRename(newstate);
    document.body.classList.remove("modal-open");
  };
  const setAddDepratmentName=(value)=>{
    if(value !== ''){
      setError('')
    }
    setDepartmentName(value)
    
  }
  
  const getDate = () => {
    setPending(true)
    getAxiosResponse(APIUrls.GET_ACTIVE_USER_GROUP_MEMBERSHIP)
      .then((res) => {
        setActiveUserGroup(res.data.data.customGroups);
        setPending(false)
      })
      .catch((err) => {
        handleError(err);
      });
  };

  const getUnAssignedDepartments = ()=>{
    getAxiosResponse(APIUrls.UNASSIGNED_DEPARTMENTS)
    .then((response)=>{
        setUnAssignedGroup(response.data.data)
    })
  };
  
  useEffect(()=>{
    getDate();
    getUnAssignedDepartments();
    $(".lastdisable").trigger("focus");
  }, [])
      
  const handleSort = async (column, sortDirection) => {
    $(".rdt_TableCol_Sortable[data-column-id='" + column.id + "']")
      .attr({ 'aria-label': column.name, 'aria-sort': sortDirection.toUpperCase() === Constants.DESC  ? Constants.DESCENDING : Constants.ASCENDING });
  };
  $(document).on("click",".datatable-block .rdt_TableCell button.inline-flex, .heading-with-rightbtn .blue-btn",function() {
    $(this).addClass('focusAdd');
 });
 $(document).on("click",".modal-footer .btn",function() {
   $('.focusAdd').trigger('focus');
   $('.inline-flex').removeClass('focusAdd');
   $('.heading-with-rightbtn .blue-btn').removeClass('focusAdd');
 });
 $(document).on("click",".cancelFocus",function() {
  $('.blue-btn').trigger('focus');
 });

 
$(".rdt_Table").attr("aria-label","Company Departments"); 
$(document).ready(function(){
 $(".rdt_Table .rdt_TableCol span").attr("aria-hidden","true"); 
 $(".rdt_TableCol .rdt_TableCol_Sortable[disabled]").attr("tabIndex","-1"); 
})
const crumbs = [
  {label:'Settings', url:'settings'},
  {label:'Company departments', url:''},
];
  return (
    <div className="body bg-color">
      <div id="container" className="dashboard-wrapper">
        <Header ref={scrollRef} />
        <LeftNavbar />
        <section className="dashboard-content" ref={scrollRef}>
          <div id="content" className="dashboard-wrap">
           <Breadcrumb crumbs={ crumbs } />
            <div className="system-setting-page">
              <div className="project-heading userprofile-heading">
                <div className="back-arrow flex-center">
                  <button ref={backRef} aria-label="Back to Settings" onClick={() => navigate("/settings")} >
                    {BackArrowIcon}
                  </button>
                  <span>Back to Settings</span>
                </div>
                <h3>Company Departments</h3>
                <span>Create departments to segment users and projects.</span>
              </div>
              <div className="white-bg">
                <div className="flex wrap-management-group">
                  <div className="company-department mar-bot40">
                    <div className="flex heading-with-rightbtn">
                      <h6>Departments</h6>
                      <div className="flex two-col flex-center">
                        <button className="blue-btn active" onClick={showAddModal} >
                          Add
                        </button>
                      </div>
                    </div>
                    <div className="table-responsive global-table">
                      
                      <div className="datatable-block">
                        <DataTable
                          keyField="userGroup.id"
                          columns={columns}
                          data={activeUserGroup}
                          //defaultSortFieldId={1}
                          onSort={handleSort}
                          responsive
                          striped
                          pointerOnHover={true}
                          progressPending={pending}
                          noDataComponent={noDataFoundComponent()}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="manage-department">
                    <div className="flex heading-with-rightbtn">
                      <h6>Manage Departments</h6>
                    </div>
                    <div className="padd-lr-15">
                      <p>Every user must be assigned to a department.</p>
                      <p>
                        To assign users to a department, go to the{" "}
                        <Link to="/settings/user-management">User Management settings page</Link> and edit
                        each user.
                      </p>
                      <p>
                        Non-Administrators only have access to projects that
                        belong to their department.
                      </p>
                      <p>
                        A department can only be deleted if it does not have any
                        associated users or projects.
                      </p>
                      <p>
                        Each department manages their own preferred vendors.
                      </p>
                      <p>
                        Learn more at the <Link onClick={()=>openNewTab("https://cloudwords.zendesk.com/hc/en-us/articles/206359763-Company-Departments")}>Help Center</Link>. 
                      </p>
                    </div>
                  </div>
                </div>
                <div className="flex wrap-management-group">
                  <div className="company-department mar-bot40">
                      <div className="flex heading-with-rightbtn">
                        <h6>Unassigned</h6>
                      </div>
                      <div className="table-responsive global-table">
                        
                        <div className="datatable-block">
                          <DataTable
                            keyField="userGroup.id"
                            columns={unAssignedColumns}
                            data={unAssignedGroup}
                            //defaultSortFieldId={1}
                            onSort={handleSort}
                            responsive
                            striped
                            pointerOnHover={true}
                            progressPending={pending}
                            noDataComponent={noDataFoundComponent()}
                          />
                        </div>
                      </div>
                  </div>
                  
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      {conDepartment ? (
        <div className="lightbox-panel" aria-labelledby="addDepartment" aria-modal="true" role="dialog">
          <div className="inner-lightbox-panel sm-lightbox-pannel pb-0">
            <div className="modal-header flex padd-lr">
              <h5 id="addDepartment">Add Department</h5>
            </div>
            <div className="lightbox-content padd-22">
              <div className="global-dropdown-block mar-bot6">
                <label>Name</label>
                <input
                  type="text"
                  className="form-control-sm"
                  title="department name"
                  id="addDepartmentInput"
                  value={departmentName}
                  onChange={(e) => setAddDepratmentName(e.target.value)} required
                />
                {error !== '' ? <div className="textDanger">{error}</div> : null}
              </div>
            </div>
            <div className="modal-footer modal-footer-border flex px-22">
              <button className="btn btn-bold first-focus cancelFocus" onClick={hideAddModal}>
                Cancel
              </button>
              <button
                className="btn btn-bold active"
                id="addDepartment"
                onClick={createDepartment}
                onKeyDown={handleKeyAddflow}
               // disabled={departmentName === "" }
              >
                Save
              </button>
            </div>
          </div>
        </div>
      ) : (
        <div className="lightbox-panel" aria-labelledby="renameDepartment" aria-modal="true" role="dialog">
          <div className="inner-lightbox-panel sm-lightbox-pannel pb-0">
            <div className="modal-header flex padd-lr">
              <h5 id="renameDepartment">Rename Department</h5>
            </div>
            <div className="lightbox-content padd-22">
              <div className="flex wrap-dropdown mb-0">
                <div className="global-dropdown-block">
                  <label>Name</label>
                  <input
                    type="text"
                    className="form-control-sm"
                    title="Rename Department"
                    id="renameInput"
                    //value=''
                    value={
                      departmentName !== ""
                        ? departmentName
                        : departmentToRename.name !== undefined
                        ? departmentToRename.name
                        : ""
                    }
                    onChange={(e) => setDepartmentName(e.target.value)}
                  />
                </div>
              </div>
            </div>
            <div className="modal-footer modal-footer-border flex px-22">
              <button className="btn btn-bold first-focus" onClick={hideRenameModal}>
                Cancel
              </button>
              <button
                className="btn btn-bold active" id="SaveId"
                onClick={renameDepartment}
                onKeyDown={handleKeyEditflow}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
